import { FormCollapse, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { FaqContent } from '../../../interfaces/FaqContent';
import { FaqResourceInfo } from '../FaqResource/FaqResource';
import Content from './Content';
import { StyledTile } from './QuestionsTile.styles';

export interface QuestionsTileProps {

}

const QuestionsTile: FC<QuestionsTileProps> = () => {
  const faqData: FaqContent[] = useScopedSelector(FaqResourceInfo.dataDst);
  return (
    <StyledTile isDivided={false}>
      {faqData?.map((v, index) => (v.question && v.answer &&
        <FormCollapse key={index} title={v.question} name={`faq-${index}`}>
          <Content answer={v.answer} />
        </FormCollapse>
      ))}
    </StyledTile>
  );
};

export default QuestionsTile;
